import React, { useMemo } from 'react';

import { OfferEligibilityReason } from '../../hooks/offer-hooks';

import { IneligibleText, StyledNoGiftIcon, Text, Wrapper } from './IneligibleForOffer-styled-components';

const DENY_REASON_TO_MESSAGE = {
  [OfferEligibilityReason.UNDER_18]: 'Rewards are only for patients 18 or older.',
  [OfferEligibilityReason.GOVT_INSURANCE]: "Rewards aren't available with government-funded insurance.",
  [OfferEligibilityReason.ALREADY_RECEIVED]: "You've already received an Opencare reward in the last 2 years.",
};

export const IneligibleForOffer = ({ denyReason }: { denyReason: OfferEligibilityReason; }) => {
  const denyReasonMessage = useMemo(
    () => DENY_REASON_TO_MESSAGE[denyReason],
    [denyReason],
  );

  return (
    <Wrapper>
      <StyledNoGiftIcon />
      <span>
        <IneligibleText>Not eligible for reward:{' '}</IneligibleText>
        <Text>{denyReasonMessage} You can still book — just without the reward.</Text>
      </span>
    </Wrapper>
  );
};
